module.exports = __webpack_public_path__ + "img/cattunnel08.ae250179.jpg";